module.exports = __webpack_public_path__ + "static/img/detailTitle-dtdh.2ebf488.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/detailTitle-dtdh.png
// module id = 9
// module chunks = 0